/**
 * Length of Stay Distribution Chart (Highcharts)
 * Column chart showing LOS distribution
 */
import { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function LengthOfStayDistributionChart({ data = [] }) {
  const options = useMemo(() => {
    if (!data || data.length === 0) {
      return {
        title: { text: 'Length of Stay Distribution' },
        subtitle: { text: 'No data available for this period/channel' },
        series: [],
      };
    }

    const buckets = ['1', '2', '3', '4-6', '7', '8-13', '14+'];
    const values = buckets.map(bucket => {
      const item = data.find(d => d.los_bucket === bucket);
      return item ? item.reservation_count : 0;
    });

    return {
      chart: {
        type: 'column',
        height: 350,
      },
      title: {
        text: 'Length of Stay Distribution',
        style: { fontSize: '16px', fontWeight: '600' },
      },
      xAxis: {
        categories: buckets.map(b => b === '4-6' ? '4-6' : b === '8-13' ? '8-13' : b === '14+' ? '14+' : b + ' night' + (b === '1' ? '' : 's')),
        title: { text: 'Length of Stay' },
      },
      yAxis: {
        title: { text: 'Number of Reservations' },
        min: 0,
      },
      tooltip: {
        backgroundColor: '#ffffff', // Fully opaque white background
        borderColor: '#e5e7eb',
        borderWidth: 1,
        style: {
          color: '#111827', // Dark text for readability
        },
        formatter: function() {
          return '<b>' + this.x + '</b><br/>' +
            'Reservations: <b>' + this.y + '</b>';
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              // Only show labels for values > 0 to avoid clutter
              if (this.y > 0) {
                return this.y;
              }
              return '';
            },
            style: {
              fontSize: '11px',
              fontWeight: '500',
              textOutline: '1px contrast',
            },
          },
        },
      },
      series: [{
        name: 'Reservations',
        data: values,
        color: '#9B59B6',
      }],
      credits: { enabled: false },
    };
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
